import {
  publish as defaultPublish,
  subscribe as defaultSubscribe,
  unsubscribe,
} from '@wh/message-bus';

const determineArguments = (topicOrObject, dataOrCallbackOfDefaultApi, isPublish) => {
  const oldApiUsed = typeof topicOrObject === 'string';
  if (oldApiUsed) {
    return [topicOrObject, dataOrCallbackOfDefaultApi];
  }
  return [topicOrObject.topic, isPublish ? topicOrObject.data : topicOrObject.callback];
};

export const publish = (topicOrObject, defaultApiData) => {
  const args = determineArguments(topicOrObject, defaultApiData, true);
  return defaultPublish(...args);
};

export const subscribe = (topicOrObject, defaultApiCallback) => {
  const args = determineArguments(topicOrObject, defaultApiCallback, false);
  return defaultSubscribe(...args);
};

export { unsubscribe };
